import axios from 'axios'
import { AuthStorage } from 'utils/helpers/auth'

export default function initAxios() {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + AuthStorage.token
}
